<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select
        ref="dataSourceSelect"
        popper-class="data-source-select-tree"
        class="w-full"
        size="small"
        v-model="form.dataSource"
        placeholder="请选择栏目"
        @visible-change="visibleSelectChange"
      >
        <el-option
          :label="columnName"
          :value="form.dataSource"
          :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
        >
          <el-tree
            :props="{
              label: 'name',
              children: 'child',
            }"
            class="text-white max-h-274px overflow-x-hidden data-source-tree"
            ref="treeRef"
            node-key="id"
            highlight-current
            :data="columnData"
            @node-click="treeNodeClick"
            :expand-on-click-node="false"
            :default-expanded-keys="defaultExpandedKeys"
          ></el-tree>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="显示名称" v-if="form.showTitle">
      <el-input
        v-model="form.title"
        placeholder="显示名称"
        @input="selectChange"
        maxlength="20"
        clearable
      />
    </el-form-item>
    <el-form-item label="显示摘要">
      <el-checkbox v-model="form.showContent" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示时间">
      <el-checkbox v-model="form.showDate" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示栏目名称">
      <el-checkbox v-model="form.showTitle" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="展示条数">
      <el-input-number
        v-model="form.row"
        :min="1"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <layoutConfig :config="config" :layout="layout" @layoutChange="layoutChange" />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import layoutConfig from './LayoutConfig'

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      form: {
        dataSource: '', // 数据来源
        showContent: true, // 显示摘要
        showDate: true, // 显示时间
        showTitle: true, // 显示栏目名称
        row: 5, // 展示行数
        title: '', // 显示名称
      },
      columnName: '',
      config: {
        w: 10,
        h: 10,
      },
      columnData: [],
      defaultExpandedKeys: [],
      columnFlattenData: [],
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.form = this.$options.data().form
        if (!_.isEmpty(val)) {
          this.columnName = ''
          _.assign(this.form, val)
          if (val.dataSource) {
            this.columnName = _.find(this.columnFlattenData, { id: val.dataSource })?.name
          }
        } else {
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'component', 'x', 'y', 'i'])
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        this.columnData = res
        this.columnFlattenData = treeToOneArray(res, 'child')
        if (this.form.dataSource) {
          this.columnName = _.find(this.columnFlattenData, { id: this.form.dataSource })?.name
        }
      }
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
    visibleSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.treeRef.setCurrentKey(this.form.dataSource) // 设置选中元素
          this.defaultExpandedKeys = [this.form.dataSource]
        } else {
          const nodeDatas = this.$refs.treeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(node) {
      this.form.dataSource = node.id
      this.columnName = node.name
      this.form.title = node.name
      this.$refs.dataSourceSelect.blur()
      this.selectChange()
    },
  },
  created() {
    this.getColumnData()
    this.selectChange()
  },
}
</script>

<style lang="scss">
.data-source-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
<style lang="scss" scoped>
.data-source-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
